import { render, staticRenderFns } from "./ticketDetailMobile.vue?vue&type=template&id=f21b27b6&scoped=true"
import script from "./ticketDetailMobile.vue?vue&type=script&lang=js"
export * from "./ticketDetailMobile.vue?vue&type=script&lang=js"
import style0 from "./ticketDetailMobile.vue?vue&type=style&index=0&id=f21b27b6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21b27b6",
  null
  
)

export default component.exports